import "@shoelace-style/shoelace/dist/components/spinner/spinner.js";

import { html } from "lit";
import { customElement, property } from "lit/decorators.js";

import { BaseElement } from "../BaseElement";
import { styles } from "./ProgressSpinner.style";

@customElement("ds-progress-spinner")
export class ProgressSpinner extends BaseElement {
    static override styles = [styles];

    @property({ type: String }) message: string | undefined;

    override render() {
        return html` <div class="loading-container">
            <span class="loading-text">${this.message ?? "Please wait..."}</span>
            <div><sl-spinner class="loading-spinner"> </sl-spinner></div>
        </div>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-progress-spinner": ProgressSpinner;
    }
}
